export default "__VITE_ASSET__nbnj4GCt__"